export const statements = {
    get: () => axios.get('/reports/transactions-statements').then((res) => res.data),
    generate: (data) => axios.post('/reports/transactions-statement', {...data}).then((res) => res.data)
}
